import script from "./ExpeditedReviewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpeditedReviewComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExpeditedReviewComponent.vue?vue&type=style&index=0&id=47cecf16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cecf16"]])

export default __exports__